function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import React, { useState } from 'react';
import { XYChart as _XYChart, Shape, Gradient, Curve, Event } from '@visx/visx';
import dayjs from '@/utils/dayjs';
import { scaleTime, scaleLinear } from '@visx/scale';
import { motion, useMotionValue, useSpring, useTransform } from 'framer-motion';
import styles from './Graph.module.scss';
import Circle from './Circle';
import classNames from 'classnames';
import { useElementSize } from '@mantine/hooks';
import { Divider } from '@mantine/core';
var Axis = _XYChart.Axis, AreaSeries = _XYChart.AreaSeries, XYChart = _XYChart.XYChart, Grid = _XYChart.Grid;
var LinePath = Shape.LinePath;
var LinearGradient = Gradient.LinearGradient;
var curveMonotoneX = Curve.curveMonotoneX;
var localPoint = Event.localPoint;
var DEFAULT_MARGIN = 48;
var TOOLTIP_OFFSET = 40;
var accessors = {
    xAccessor: function(d) {
        return new Date("".concat(d.x, "T00:00:00"));
    },
    yAccessor: function(d) {
        return d.y;
    }
};
function getPathYFromX(x, path, name, error) {
    error = error !== null && error !== void 0 ? error : 0.01;
    var maxIterations = 100;
    var lengthStart = 0;
    var lengthEnd = path.getTotalLength();
    var point = path.getPointAtLength((lengthEnd + lengthStart) / 2);
    var iterations = 0;
    while(x < point.x - error || x > point.x + error){
        var midpoint = (lengthStart + lengthEnd) / 2;
        point = path.getPointAtLength(midpoint);
        if (x < point.x) {
            lengthEnd = midpoint;
        } else {
            lengthStart = midpoint;
        }
        iterations += 1;
        if (maxIterations < iterations) {
            break;
        }
    }
    return point.y;
}
export function Glyph(_param) {
    var _param_shouldTranslate = _param.shouldTranslate, shouldTranslate = _param_shouldTranslate === void 0 ? true : _param_shouldTranslate, className = _param.className, props = _object_without_properties(_param, [
        "shouldTranslate",
        "className"
    ]);
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
        className: classNames(styles.glyphContainer, className, _define_property({}, styles.translate, shouldTranslate))
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Circle, {
                className: styles.circle
            }),
            /*#__PURE__*/ _jsx(Circle, {
                className: styles.smallCircle
            })
        ]
    }));
}
export function Graph(param) {
    var dataKey = param.dataKey, data = param.data, linearGradientProps = param.linearGradientProps, seriesStrokeColor = param.seriesStrokeColor, curve = param.curve;
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Axis, {
                hideTicks: true,
                strokeWidth: 0,
                orientation: "left",
                numTicks: 4
            }),
            /*#__PURE__*/ _jsx(LinearGradient, _object_spread({
                id: dataKey
            }, linearGradientProps)),
            /*#__PURE__*/ _jsx(AreaSeries, _object_spread({
                dataKey: dataKey,
                data: data,
                curve: curve !== null && curve !== void 0 ? curve : curveMonotoneX,
                lineProps: {
                    stroke: seriesStrokeColor
                },
                fill: "url(#".concat(dataKey, ")")
            }, accessors))
        ]
    });
}
function GraphGlyph(_param) {
    var dataKey = _param.dataKey, svgPath = _param.svgPath, leftVerticalLineSpring = _param.leftVerticalLineSpring, glyphProps = _param.glyphProps, props = _object_without_properties(_param, [
        "dataKey",
        "svgPath",
        "leftVerticalLineSpring",
        "glyphProps"
    ]);
    var topY = useTransform(leftVerticalLineSpring, function(x) {
        if (svgPath == null || !_instanceof(svgPath, SVGPathElement)) {
            return 0;
        }
        return getPathYFromX(x, svgPath, 'messages');
    });
    return /*#__PURE__*/ _createElement(motion.div, _object_spread_props(_object_spread({}, props), {
        key: dataKey,
        initial: {
            opacity: 0
        },
        transition: {
            duration: 0.25
        },
        className: styles.graphIndicator,
        style: {
            y: topY,
            x: leftVerticalLineSpring
        }
    }), /*#__PURE__*/ _jsx(Glyph, {
        className: classNames(styles.glyph, glyphProps.className)
    }));
}
export function GraphContainer(param) {
    var children = param.children, data = param.data, width = param.width, height = param.height, _param_margin = param.margin, margin = _param_margin === void 0 ? DEFAULT_MARGIN : _param_margin, curve = param.curve, renderTooltip = param.renderTooltip;
    var pathRefs = React.useRef({});
    var _useState = _sliced_to_array(useState({
        tooltipOpen: false,
        tooltipDatum: undefined
    }), 2), _useState_ = _useState[0], tooltipOpen = _useState_.tooltipOpen, tooltipDatum = _useState_.tooltipDatum, setTooltip = _useState[1];
    var leftVerticalLineSpring = useSpring(0, {
        stiffness: 700,
        damping: 125
    });
    var tooltipTop = useMotionValue(0);
    var _useElementSize = useElementSize(), tooltipRef = _useElementSize.ref, tooltipWidth = _useElementSize.width, tooltipHeight = _useElementSize.height;
    var innerWidth = React.useMemo(function() {
        return width - margin * 2;
    }, [
        width,
        margin
    ]);
    var innerHeight = React.useMemo(function() {
        return height - margin * 2;
    }, [
        height,
        margin
    ]);
    var xScale = React.useMemo(function() {
        return scaleTime({
            domain: [
                new Date(data[0].x),
                new Date(data[data.length - 1].x)
            ],
            range: [
                0,
                innerWidth
            ]
        });
    }, [
        data,
        innerWidth
    ]);
    var handlePointerMove = React.useCallback(function(param) {
        var datum = param.datum, event = param.event;
        if (event == null) {
            return;
        }
        var _localPoint;
        var y = ((_localPoint = localPoint(event)) !== null && _localPoint !== void 0 ? _localPoint : {
            x: 0,
            y: 0
        }).y;
        var _xScale;
        var newLeftVerticalLine = (_xScale = xScale(new Date(datum.x))) !== null && _xScale !== void 0 ? _xScale : 0;
        var tooltipY = Math.min(Math.max(y - TOOLTIP_OFFSET, margin), height - tooltipHeight - margin);
        leftVerticalLineSpring.set(newLeftVerticalLine + margin);
        tooltipTop.set(tooltipY);
        setTooltip(function(prev) {
            if (prev.tooltipDatum === datum) {
                return prev;
            }
            return {
                tooltipOpen: true,
                tooltipDatum: datum
            };
        });
    }, [
        height,
        leftVerticalLineSpring,
        margin,
        tooltipHeight,
        tooltipTop,
        xScale
    ]);
    var graphProps = React.useMemo(function() {
        var childProps = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = React.Children.toArray(children)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                if (!/*#__PURE__*/ React.isValidElement(child) || child.type !== Graph) {
                    continue;
                }
                childProps.push(child.props);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return childProps;
    }, [
        children
    ]);
    var maxYScale = React.useMemo(function() {
        var _Math;
        if (graphProps == null || graphProps.length === 0) {
            return 0;
        }
        var coordinates = graphProps.flatMap(function(d) {
            return d.data;
        });
        return (_Math = Math).max.apply(_Math, _to_consumable_array(coordinates.map(function(d) {
            return d.y;
        })));
    }, [
        graphProps
    ]);
    var yScale = React.useMemo(function() {
        return scaleLinear({
            domain: [
                0,
                maxYScale
            ],
            range: [
                innerHeight,
                0
            ]
        });
    }, [
        maxYScale,
        innerHeight
    ]);
    var pathRef = React.useCallback(function(dataKey, path) {
        if (path == null) {
            return;
        }
        pathRefs.current[dataKey] = path;
    }, []);
    var tooltipLeft = useTransform(leftVerticalLineSpring, function(x) {
        if (x > innerWidth / 2) {
            return x - tooltipWidth - TOOLTIP_OFFSET;
        }
        return x + TOOLTIP_OFFSET;
    });
    if (width <= 0 || height <= 0) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.graph,
        style: {
            width: width,
            height: height
        },
        children: [
            /*#__PURE__*/ _jsx(motion.div, {
                transition: {
                    duration: 0.1
                },
                initial: {
                    opacity: 0
                },
                animate: {
                    opacity: tooltipOpen ? 1 : 0
                },
                className: styles.graphIndicator,
                style: {
                    y: margin,
                    x: leftVerticalLineSpring
                },
                children: /*#__PURE__*/ _jsx(Divider, {
                    orientation: "vertical",
                    style: {
                        height: innerHeight
                    }
                })
            }),
            graphProps.map(function(param) {
                var dataKey = param.dataKey, glyphProps = param.glyphProps;
                return /*#__PURE__*/ _jsx(GraphGlyph, {
                    dataKey: dataKey,
                    svgPath: pathRefs.current[dataKey],
                    animate: {
                        opacity: tooltipOpen ? 1 : 0
                    },
                    leftVerticalLineSpring: leftVerticalLineSpring,
                    glyphProps: glyphProps
                }, dataKey);
            }),
            /*#__PURE__*/ _jsx(motion.div, {
                ref: tooltipRef,
                style: {
                    left: tooltipLeft,
                    top: tooltipTop
                },
                initial: {
                    opacity: 0
                },
                animate: {
                    opacity: tooltipOpen ? 1 : 0
                },
                transition: {
                    duration: 0.3
                },
                className: styles.graphIndicator,
                children: renderTooltip(tooltipDatum)
            }),
            /*#__PURE__*/ _jsxs(XYChart, {
                width: width,
                height: height,
                xScale: {
                    type: 'time'
                },
                yScale: {
                    type: 'linear'
                },
                margin: {
                    top: margin,
                    right: margin,
                    bottom: margin,
                    left: margin
                },
                onPointerMove: handlePointerMove,
                onPointerOut: function() {
                    return setTooltip({
                        tooltipOpen: false,
                        tooltipDatum: undefined
                    });
                },
                children: [
                    /*#__PURE__*/ _jsx(Grid, {
                        lineStyle: {
                            stroke: 'inherit'
                        },
                        className: styles.grid
                    }),
                    children,
                    graphProps.map(function(param) {
                        var dataKey = param.dataKey, data = param.data;
                        return /*#__PURE__*/ _jsx(LinePath, {
                            data: data,
                            x: function(d) {
                                return xScale(new Date(d.x)) + margin;
                            },
                            y: function(d) {
                                return yScale(d.y) + margin;
                            },
                            stroke: "transparent",
                            curve: curve !== null && curve !== void 0 ? curve : curveMonotoneX,
                            innerRef: function(path) {
                                return pathRef(dataKey, path);
                            },
                            style: {
                                display: 'none'
                            }
                        }, "".concat(dataKey, "-stroke"));
                    }),
                    /*#__PURE__*/ _jsx(Axis, {
                        hideTicks: true,
                        orientation: "bottom",
                        strokeWidth: 0,
                        numTicks: data.length,
                        tickFormat: function(d) {
                            return dayjs(d).format('ddd');
                        }
                    })
                ]
            })
        ]
    });
}
